import { Outlet, Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nProvider';
import LanguageSwitcher from '../components/LanguageSwitcher';

export default function PublicLayout() {
  const { t } = useI18n();

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <img src="https://static.readdy.ai/image/e50d925263add9c47b947a5709171c8c/894de08e385da480c4cd82df0969ba30.png" alt="EasyDigitalDVD" className="h-10" />
            </Link>
            <nav className="flex items-center gap-4">
              <LanguageSwitcher />
              <Link 
                to="/login" 
                className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
              >
                {t('marketing.nav.login')}
              </Link>
              <Link 
                to="/register" 
                className="px-4 py-2 text-sm font-medium bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                {t('marketing.nav.signup')}
              </Link>
            </nav>
          </div>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
